// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B07LS","field":"styles_field__16Cya","fieldCol":"styles_fieldCol__twNXV","diffCol":"styles_diffCol__2m90L","diff":"styles_diff__218Z0"};